import React from 'react';
import PropTypes from 'prop-types'

export default function CircleAlertFill({ fill })
{
  return (
    <svg id="Fill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill={fill}>
      <path d="M50,86A36,36,0,1,0,14,50,36,36,0,0,0,50,86ZM45.5,30.25h9v24.5h-9ZM50,60.75a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,50,60.75Z" />
    </svg>
  )
}

CircleAlertFill.propTypes = {
  fill: PropTypes.string
};